'use strict';

/**
 *
 * @name: nnModalsService
 *
 */

function NnModalsService($rootScope, $location, $timeout) {

  'ngInject';

  /**
   *
   * @CONFIG
   *
  **/

  var visibleModal = null;
  var scrollBinded = false;
  var scrollTop;

  $timeout(() => {
    _updateVisibleModalValue($location.search().modal || null)
  })

  window.addEventListener('keyup', event => {
    if (visibleModal && event && event.key) {
      if (event.key.toLowerCase() === 'escape' || event.code.toLowerCase() === 'escape') {
        hideModal(visibleModal)
      }
    }
  })

  // Prevent loosing scroll
  window.addEventListener('scroll', function(event) {

    if(isModalVisible()){
      $rootScope.$apply(function(){
        console.log('tried to fix', {eTarget: event.target})
        document.querySelector('.modal-content').focus()
      })
    }
  });

  /**
   *
   * @PUBLIC
   *
  **/


  function showModal(modalName){

    if(!isModalVisible()){
      scrollTop = $(window).scrollTop()
    }

    $timeout(() => {
      _updateVisibleModalValue(modalName)

      $timeout(() => {
        $rootScope.dynamicStyles()
      })

      $timeout(() => {
        _bindScroll()
      }, 1500)
    })
  }

  function hideModal(modalName, scrollTo){
    if (!visibleModal) {
      return
    }

    /*jshint unused:false*/

    scrollTo = (typeof scrollTo === 'undefined') ? true : scrollTo;

    $timeout(() => {
      _updateVisibleModalValue(null)

      if(scrollTo){
        $timeout(() => {
          $([document.documentElement, document.body]).animate({ scrollTop }, 300);
        })
      } else {
        scrollTop = 0
      }

      $timeout(() => {
        $rootScope.dynamicStyles()
      })

      $timeout(() => {
        _unbindScroll()
      })
    })
  }

  function toggleModal(modalName){
    $timeout(() => {
      var isCurrentVisibleModal = (modalName === visibleModal)

      if(isCurrentVisibleModal){
        hideModal()
      } else {
        showModal(modalName)
      }
    })
  }

  function isModalVisible(modalName){

    if(Array.isArray(modalName)){
      var val = modalName.some(item => (item === visibleModal))
      return val
    } else if(modalName){
      return (modalName === visibleModal)
    } else {
      return !!visibleModal
    }
  }

  /**
   *
   * @PRIVATE
   *
  **/

  function _updateVisibleModalValue(value){

    visibleModal = value

    if(visibleModal){
      document.body.classList.add('modal-visible');
    } else {
      document.body.classList.remove('modal-visible');
    }

    $rootScope.disableAnchorScroll = true;

    if(!visibleModal){
      var locationSearch = $location.search()
      var newLocationSearch = Object.keys(locationSearch)
        .reduce((res, key) => {
          if(key !== 'modal' && key !== 'search'){
            res[key] = locationSearch[key];
          }
          return res;
        }, {})

      $location.search(newLocationSearch)
    } else {
      $location.search('modal', visibleModal);
    }
  }

  function _onScroll(){
    console.log('scrolling', {activeEl: document.activeElement});
  }

  function _bindScroll(){
    if(scrollBinded){
      return
    }

    try {

      const modal = document.querySelector('.modal');

      if(modal){
        modal.addEventListener('scroll', _onScroll);
        scrollBinded = true;
        console.log('we made it!')
      }
    } catch(error) {
      _bindScroll()
    }
  }

  function _unbindScroll(){
    const modal = document.querySelector('.modal');

    if(modal){
      modal.removeEventListener('scroll', _onScroll);
    }
  }

  return {
    showModal,
    hideModal,
    toggleModal,
    isModalVisible,
    visibleModal:() => (visibleModal)
  };
}

export default NnModalsService;



// WEBPACK FOOTER //
// ./app/components/nn-modals/nn-modals.service.js